import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { CommonHttpService } from '../commonHttp.service';
import { LoaderService } from '../../_shared/services/loader.service';

@Component({
  selector: 'app-successful-order',
  templateUrl: './successful-order.component.html',
  styleUrls: ['./successful-order.component.css']
})
export class SuccessfulOrderComponent implements OnInit {
  baseUrl: any = environment.apiUrl;
  status: any;
  orderId: any;
  orderDetails: any = {};
  allDetails: any = []
  constructor(private service: CommonHttpService, private router: Router, private route: ActivatedRoute, private loaderService: LoaderService) { }

  ngOnInit() {
    window.scrollTo(0, 0)
    this.route.queryParams.subscribe(params => {
      this.status = params['status']
      this.orderId = params['orderId']
    });
    this.loadData()
  }

  async loadData() {
    console.log(this.orderId)
    for (let i = 0; i < this.orderId.length; i++) {


      this.loaderService.display(true);
      // this.orderId.split(',')

      await this.service.get(this.baseUrl + 'EOrderAPI/GetSingleOrder/' + this.orderId[i])
        .subscribe(
          data => {
            console.log(data)
            this.orderDetails = data;
            this.allDetails.push(this.orderDetails)
            this.sendSMS();
            this.sendMail()
            this.loaderService.display(false);
          },
          (error) => {
            this.loaderService.display(false);
          })
    }


  }


  async sendMail() {
    if (this.status == 'true') {
      let sendData = { CustomerMail: this.orderDetails.customerEmail, Subject: "Order Placed SuccessFully", Message: "Your order " + this.orderDetails.eNowOrderNo + " has been placed Successfully. Thank you for shopping with NowGrocery." }
      await this.service.create(this.baseUrl + 'EmailAPI/EmailSend', sendData)
        .subscribe(
          data => {
            console.log(data)
            this.loaderService.display(false);
          },
          (error) => {
            this.loaderService.display(false);
          });
    }
  }

  async sendSMS() {
    let sendData = {
      CustomerMobile: this.orderDetails.customerMobile,
      TextMsg: "Thanks for your order at NowGrocery.Your order no is " + this.orderDetails.eorderNo + ".Our executive will reach you soon for confirmation.For more reach us at 18003131533."
    }

    await this.service.create(this.baseUrl + 'SMSAPI/SendSMS', sendData)
      .subscribe(
        data => {
          console.log(data)
          this.loaderService.display(false);
        },
        (error) => {
          this.loaderService.display(false);

        });
  }


}



// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/successful-order/successful-order.component.ts